import { render, staticRenderFns } from "./ReceiptsInvoice.vue?vue&type=template&id=505b0c02&"
import script from "./ReceiptsInvoice.vue?vue&type=script&lang=js&"
export * from "./ReceiptsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505b0c02')) {
      api.createRecord('505b0c02', component.options)
    } else {
      api.reload('505b0c02', component.options)
    }
    module.hot.accept("./ReceiptsInvoice.vue?vue&type=template&id=505b0c02&", function () {
      api.rerender('505b0c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/ReceiptsInvoice.vue"
export default component.exports